import axios from 'axios';
import { URL_ENDPOINT } from '../../../index';

export const _getFeaturedCategories = () => {
    return axios({
        method: 'get',
        withCredentials: true,
        url: `${URL_ENDPOINT}/api/category/featured/all`,
        
    })
}

export const _postFeaturedCategories = (featuredCategories) => {
    console.log(featuredCategories)
    return axios ({
        method: 'post',
        withCredentials: true,
        url: `${URL_ENDPOINT}/api/category/featured`,
        data: { featuredCategories }
    })
}



// WEBPACK FOOTER //
// ./src/components/featured/actions/index.js